import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency'
})
export class CurrencyPipe implements PipeTransform {

  constructor() {}

  transform(value: string, args: any): string {

    let currencySign;
    switch (value) {
      case 'EUR':
        currencySign = '€';
        break;
      case 'USD':
        currencySign = '$';
        break;
      case 'DKK':
        currencySign = 'DKK';
        break;
      case 'INR':
        currencySign = 'INR';
        break;
      default:
        currencySign = ''
    };
    return currencySign;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/currency.pipe.ts